<template>
  <q-page padding>
    <div class="row col-12 justify-between">
      <section>
        <p class="text-h6 text-brand-5 text-weight-bold">
          Editar Inventário
          <span v-if="inventario.deposito" class="text-black">{{
            inventario.deposito.nome
          }}</span>
        </p>
        <p
          v-if="inventario.created_at"
          class="text-h6 text-brand-5 text-weight-bold"
        >
          Criado em:
          {{
            inventario.created_at?.date
              ?.split(" ")[0]
              ?.split("-")
              .reverse()
              .join("/")
          }}
          | Status Atual:
          <span v-if="inventario.status" class="text-black">{{
            inventario.status
          }}</span>
        </p>
      </section>
      <div>
        <router-link
          :to="{
            name: 'inventario-listar',
          }"
        >
          <div
            style="cursor: pointer"
            class="row items-center text-weight-bold text-brand-5 q-mr-md container-link-voltar"
          >
            <q-icon class="q-mr-sm icon-voltar" name="west" color="brand-5" />
            <span style="font-size: 20px">Voltar</span>
          </div>
        </router-link>
      </div>
    </div>

    <section v-if="inventario.status != 'Finalizado'" class="row">
      <div style="width: 50%" class="q-pa-md q-mt-lg">
        <q-table
          flat
          style="height: 400px"
          table-header-class="bg-accent text-width-bold"
          title="Lista de Grupos"
          :rows="rows"
          class="tabela-tamanho-fixo"
          dense
          :columns="columns"
          :loading="disable"
          hide-pagination
          :rows-per-page-options="[0]"
        >
          <template v-slot:top-right>
            <q-input
              rounded
              outlined
              dense
              debounce="300"
              v-model="filtrar"
              placeholder="Filtrar por grupo"
            >
              <template v-slot:append>
                <q-icon name="search" />
              </template>
            </q-input>
          </template>
          <template #body-cell-selecione="props">
            <q-td>
              <q-radio v-model="selecionado" :val="props.row" />
            </q-td>
          </template>
        </q-table>
      </div>
      <div style="width: 50%" class="q-pa-md q-mt-lg">
        <q-table
          flat
          style="height: 400px"
          table-header-class="bg-accent text-width-bold"
          title="Lista de Produtos do grupo"
          :rows="rows2"
          class="tabela-tamanho-fixo"
          :columns="columns2"
          dense
          :loading="disable"
          hide-pagination
          :rows-per-page-options="[0]"
        >
          <template v-slot:top-right>
            <q-input
              rounded
              outlined
              dense
              debounce="300"
              v-model="filtrarProduto"
              placeholder="Filtrar por produto"
            >
              <template v-slot:append>
                <q-icon name="search" />
              </template>
            </q-input>
          </template>
          <template #body-cell-selecione="props">
            <q-td>
              <q-btn
                color="positive"
                round
                size="sm"
                icon="add"
                :disabled="
                  inventario.produtos_conferencia.find((e) => {
                    return e.id == props.row.id;
                  })
                "
                @click="adidionar(props.row.id)"
              />
            </q-td>
          </template>
        </q-table>
      </div>
    </section>

    <adicionados :atualizar="atualizar" @mudarStatus="getDados" />
  </q-page>
</template>

<script>
const columns = [
  {
    name: "selecione",
    label: "Selecionar",
    field: "selecione",
    align: "left",
  },
  {
    name: "name",
    label: "Grupos",
    field: "name",
    align: "left",
  },
];

const columns2 = [
  {
    name: "selecione",
    label: "Selecionar",
    field: "selecione",
    align: "left",
  },
  {
    name: "code",
    label: "Código",
    field: "code",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "description",
    label: "Descrição",
    field: (row) =>
      row.pivot && row.pivot.contract_product_description
        ? row.pivot.contract_product_description
        : "",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "name",
    label: "Preço",
    field: (row) =>
      row.pivot && row.pivot.price
        ? "R$" + " " + Number(row.pivot.price).toFixed(2)
        : "",
    style: "white-space: normal",
    align: "left",
  },
  {
    name: "name",
    label: "Endereço",
    field: (row) =>
      row.stock[0] && row.stock[0].pivot && row.stock[0].pivot.address
        ? row.stock[0].pivot.address
        : "",
    style: "white-space: normal",
    align: "left",
  },
];

import { ref, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRoute } from "vue-router";
import Adicionados from "../components/Adicionados.vue";
export default {
  components: { Adicionados },
  setup() {
    const store = useStore();
    const $q = useQuasar();
    const $route = useRoute();
    const id = $route.params.id;
    const inventario = ref("");
    const rows = ref([]);
    const rows2 = ref([]);
    const destinoId = ref([]);
    const atualizar = ref(0);
    const filtrar = ref("");
    const filtrarProduto = ref("");
    const selecionadoDados = ref([]);
    const selecionado = ref([]);
    const disable = ref(true);

    const getDados = async () => {
      try {
        const response = await store.dispatch("inventario/getInventario", {
          id: id,
        });

        inventario.value = await response.data.result;
        getProdutos();
      } catch (error) {
        $q.notify({
          message: "Erro a o encontrar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getProdutos = async () => {
      try {
        const response = await store.dispatch("inventario/getProdutos", {
          vendor_id: await inventario.value.deposito.id,
          search: filtrar.value,
        });

        rows.value = response.data.results.data;
        rows.value.unshift({ name: "Todos", id: "" });
        disable.value = false;
      } catch (error) {
        $q.notify({
          message: "Erro a o encontrar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getSelecionado = async () => {
      disable.value = true;
      rows2.value = [];
      try {
        const response = await store.dispatch("inventario/getProduto", {
          contract_id: await inventario.value.deposito.contract_id,
          group_id: await selecionado.value.id,
          search: filtrarProduto.value,
          per_page: 50,
        });

        rows2.value = response.data.model.products.data;
        disable.value = false;
      } catch (error) {
        $q.notify({
          message: "Erro a o encontrar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const adidionar = async (id) => {
      let produto = [{ id: id }];
      try {
        await store.dispatch("inventario/adicionarProduto", {
          inventory_id: await inventario.value.uuid,
          products: produto,
        });

        $q.notify({
          message: "Produto adicionado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        atualizar.value++;
        getDados();
      } catch (error) {
        const errorMessage =
          error?.response?.data?.result?.error || "Erro ao adicionar produto";

        $q.notify({
          message: errorMessage,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    watch(
      () => selecionado.value,
      () => {
        getSelecionado();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        getDados();
      }
    );

    watch(
      () => filtrar.value,
      () => {
        getProdutos();
      }
    );

    watch(
      () => filtrarProduto.value,
      () => {
        getSelecionado();
      }
    );

    return {
      rows,
      rows2,
      disable,
      columns,
      columns2,
      getDados,
      selecionado,
      getSelecionado,
      destinoId,
      adidionar,
      selecionadoDados,
      getProdutos,
      inventario,
      atualizar,
      filtrar,
      filtrarProduto,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>
